import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as fromServices from '../../services';
import { ModalService } from '../../services/modal.service';
import { AboutMigrantsSeasonalToolComponent } from '../modal/about-migrants-seasonal/about-migrants-seasonal.component';
import { AboutOrganTransportComponent } from '../modal/about-organ-transport/about-organ-transport.component';
import { AboutThisToolComponent } from '../modal/about-this-tool/about-this-tool.component';
import { ModalComponent } from '../modal/modal.component';
import { NoteToHrsaComponent } from '../modal/note-to-hrsa/note-to-hrsa.component';

@Component({
  selector: 'hdw-resource-content',
  templateUrl: './resource-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResourceContentComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private toolIdentifierService: fromServices.ToolIdentifierService
  ) {}
  public locatorToolNames = fromServices.LocatorTools;
  public showInfo: boolean;
  public locatorToolName: fromServices.LocatorTools = fromServices.LocatorTools.HealthCenter;
  public canShowResources: boolean = false;

  public ngOnInit(): void {
    this.locatorToolName = this.toolIdentifierService.getCurrentTool();
  }

  public noteToHrsaHealthCenters(): void {
    this.modalService.open(ModalComponent, {
      title: 'Note to HRSA Health Centers',
      componentType: NoteToHrsaComponent
    });
  }

  public aboutThisTool(): void {
    this.modalService.open(ModalComponent, {
      title: 'About This Tool',
      componentType: AboutThisToolComponent
    });
  }

  public aboutOrganTransportCenters(): void {
    this.modalService.open(ModalComponent, {
      title: 'About Organ Transplantation',
      componentType: AboutOrganTransportComponent
    });
  }

  public aboutMigrantAndSeasonal(): void {
    this.modalService.open(ModalComponent, {
      title: 'Find a Migrant and Seasonal Head Start (MSHS)',
      componentType: AboutMigrantsSeasonalToolComponent
    });
  }

  public handleOpenInfo(): void {
    this.showInfo = !this.showInfo;
  }

  public handleCanShowResources(): void {
    this.canShowResources = !this.canShowResources;
  }
}
